const helpSectionPages = {
  data: [
    {
      id: 1,
      attributes: {
        Title: 'YMCA Directory Information',
        page: 'ymca-directory-information',
        Instruction:
          '<p>Please review your Association and Branch information below. If any changes are needed please email the information to <a href="mailto:cms.info@ymca.net">cms.info@ymca.net</a>. Please review the NCMS Manual <a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/MjIxNDk">Section 15</a> and <a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/MjIxNzQ">Section 17</a> for additional information regarding changing a Ys address. &nbsp;&nbsp;&nbsp;<br>&nbsp;</p>',
        createdAt: '2022-10-13T12:18:26.927Z',
        updatedAt: '2023-01-05T17:40:08.619Z',
        publishedAt: '2022-11-04T12:02:07.554Z'
      }
    },
    {
      id: 2,
      attributes: {
        Title: 'Site Information',
        page: 'site-information',
        Instruction:
          '<p>Enter the total number of sites by programming and location type.&nbsp;These totals should reflect the number of sites, not the number of activities at a site (e.g., a site that offers both before and&nbsp;afterschool&nbsp;programming is counted once)&nbsp;across your association.</p>',
        createdAt: '2022-10-13T12:19:08.967Z',
        updatedAt: '2022-11-17T13:14:01.887Z',
        publishedAt: '2022-10-13T12:19:10.887Z'
      }
    },
    {
      id: 3,
      attributes: {
        Title: 'Employee ',
        page: 'employee',
        Instruction:
          '<p><span style="font-family:Verdana, Geneva, sans-serif;">As part of the annual report nonfinancial process you will be asked to review and update your employee records&nbsp;</span><span style="color:#32363A;font-family:Verdana, Geneva, sans-serif;">via the Employee Update Module<strong> </strong>or via<strong>&nbsp;</strong></span><a target="_blank" rel="noopener noreferrer" href="https://moyp.yexchange.org/"><span style="color:#00AEEF;font-family:Verdana, Geneva, sans-serif;"><u>Manage Our Y Profile (MOYP)</u></span><span style="color:#007AC0;font-family:Verdana, Geneva, sans-serif;">.</span></a><span style="color:#32363A;font-family:Verdana, Geneva, sans-serif;"><strong>&nbsp;</strong></span><span style="font-family:Verdana, Geneva, sans-serif;">The Employee Update Module will allow you to edit or replace individual employee records currently listed in MOYP via a bulk upload process. To access the Employee Update Module, please navigate back to the home page of the Data Collection Hub.&nbsp;</span></p><p><span style="font-family:Verdana, Geneva, sans-serif;">Please provide the headcount information requested below and review the consent language that will be presented when you update your employee records.</span></p>',
        createdAt: '2022-10-13T12:19:41.727Z',
        updatedAt: '2022-12-07T21:25:54.063Z',
        publishedAt: '2022-10-13T12:19:43.446Z'
      }
    },
    {
      id: 7,
      attributes: {
        Title: 'Members',
        page: 'members',
        Instruction:
          '<p>The Members portion of the Constituency Report asks you to report on your total facility Members. The questions are based on whether or not you offer memberships or participate in Nationwide Membership.&nbsp;</p>',
        createdAt: '2022-10-13T12:21:29.426Z',
        updatedAt: '2022-12-07T19:37:48.420Z',
        publishedAt: '2022-10-13T12:21:31.145Z'
      }
    },
    {
      id: 8,
      attributes: {
        Title: 'Members Demographics',
        page: 'members-demographics',
        Instruction:
          '<p>Please enter your total facility Members per racial/ethnic categories for which you collect member data. Please click in the checkbox if this race/ethnic category is not collected.</p>',
        createdAt: '2022-10-13T12:21:52.168Z',
        updatedAt: '2022-11-14T16:58:30.194Z',
        publishedAt: '2022-10-13T12:21:53.521Z'
      }
    },
    {
      id: 9,
      attributes: {
        Title: 'Program Members',
        page: 'program-members',
        Instruction:
          '<p>Enter the total number of Program Member / Participant - any person that participated in a program who is NOT included in your facility Members count section. As a reminder, please use unduplicated counts if possible (Unduplicated counts mean counting a person only once, regardless of how many program sessions they enrolled in during the year.)</p><p>If your Y <strong>does not</strong> offer programs, you will skip to the Volunteers section. If your Y <strong>does&nbsp;</strong>offer programs, you will continue with the questions in this section.&nbsp;</p>',
        createdAt: '2022-10-13T12:22:21.178Z',
        updatedAt: '2022-11-10T18:38:28.597Z',
        publishedAt: '2022-10-13T12:22:22.456Z'
      }
    },
    {
      id: 10,
      attributes: {
        Title: 'Program Enrollments',
        page: 'program-enrollments',
        Instruction:
          '<p>Enter your total program enrollment numbers, regardless of whether a person was in one or more sessions. This is a full-year tally of all program participants and enrollments at your Association, including all branches and across all programs, in 2022. For before and after school enrollments, we want to see the enrollments for the calendar year, not the school year.</p><p><span style="color:hsl(0,75%,60%);font-size:13px;"><i><strong>Note</strong>: It\'s necessary to enter a zero if there are none.</i></span></p>',
        createdAt: '2022-10-13T12:22:43.325Z',
        updatedAt: '2022-12-23T11:19:39.512Z',
        publishedAt: '2022-10-13T12:22:45.057Z'
      }
    },
    {
      id: 11,
      attributes: {
        Title: 'Volunteers',
        page: 'volunteers',
        Instruction:
          '<p>In this section, report the total (annual) volunteers and volunteer hours (policy and program) across the association, including all branches and sites. Include all volunteers, whether their services would have to have been paid for by the YMCA or not. The distinction between policy and program volunteers can be found in the ‘help’ window on the right hand side of this page.</p><p><span style="color:hsl(0, 75%, 60%);font-size:13px;"><i><strong>Note</strong>: It\'s necessary to enter a zero if there are none, otherwise the form will save partially.</i></span></p>',
        createdAt: '2022-10-13T12:23:10.544Z',
        updatedAt: '2022-11-30T09:33:08.630Z',
        publishedAt: '2022-10-13T12:23:12.015Z'
      }
    },
    {
      id: 12,
      attributes: {
        Title: 'Donors',
        page: 'donors',
        Instruction:
          'In this section report the total number of individuals and organizations who made donations toward your Y at any time throughout the year. Include donations from any source and regardless of source or fund, such as annual or capital campaigns, special events, endowment development, federated giving (United Way), as well as unsolicited “general contributions”, etc. ',
        createdAt: '2022-10-13T12:23:31.729Z',
        updatedAt: '2022-10-13T12:23:33.558Z',
        publishedAt: '2022-10-13T12:23:33.556Z'
      }
    },
    {
      id: 13,
      attributes: {
        Title: 'Organizational Commitment',
        page: 'organizational-commitment',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.</p>',
        createdAt: '2022-10-13T12:23:51.216Z',
        updatedAt: '2022-11-02T09:43:57.036Z',
        publishedAt: '2022-10-13T12:23:52.745Z'
      }
    },
    {
      id: 15,
      attributes: {
        Title: 'Program and Activities',
        page: 'program-and-activities',
        Instruction:
          'This is a branch-level section. Please submit one survey per corporate association and branch. Please complete the survey for the building/s or site of your branch or association only. If you’re a corporate with branches, don’t describe your branches here, just your corporate site. If you’re a branch, submit only for your branch. ',
        createdAt: '2022-10-13T12:24:32.319Z',
        updatedAt: '2022-10-13T12:24:34.598Z',
        publishedAt: '2022-10-13T12:24:34.596Z'
      }
    },
    {
      id: 16,
      attributes: {
        Title: 'Upload Employee Data',
        page: 'upload-employee-data',
        Instruction:
          '<p>Follow the steps below to edit or replace individual employee records in Manage Our Y Profile (MOYP) System via a bulk upload process. Detailed instructions needed to successfully complete each step can be found in the <a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/NTEwNzc1">Employee Update Guide.</a> The help pane (righthand side) of this page contains instructions for enabling MACROs in your excel template once it is downloaded.</p>',
        createdAt: '2022-10-18T09:17:45.791Z',
        updatedAt: '2023-02-15T18:29:30.327Z',
        publishedAt: '2022-10-18T09:18:28.827Z'
      }
    },
    {
      id: 17,
      attributes: {
        Title: 'Employee update review',
        page: 'employee-update-review',
        Instruction:
          '<p>Please review the data you have uploaded using the table below. Once your data has been reviewed and finalized, please scroll to the bottom of this page in order to finalize and submit your updates. Uploads will then sync with Manage Our Y Profile (MOYP).<br>&nbsp;</p><p>IMPORTANT: In order to finalize and submit your updates, the review screen below will need to show zero errors. Otherwise you will not be able to complete the update process. To resolve any identified errors, make corrections to your excel file and re-upload. &nbsp;Please refer to the <a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/NTEwNzc1">Employee Update Guide</a> for more detailed step-by-step instructions for completing this process.</p>',
        createdAt: '2022-10-20T11:48:18.108Z',
        updatedAt: '2023-02-15T18:31:00.265Z',
        publishedAt: '2022-10-20T11:48:20.072Z'
      }
    },
    {
      id: 22,
      attributes: {
        Title: 'Sub Members',
        page: 'sub-members',
        Instruction:
          '<p>Please enter your total facility Members: All individual members tied to a membership type that is not "program member"/"program participation". For example, children are counted as members if they belong to the household membership of an adult in their household.&nbsp;<br>As a reminder, please use unduplicated counts if possible (Unduplicated counts mean counting a person only once, regardless of how many memberships they had during the year).</p>',
        createdAt: '2022-10-28T06:30:06.074Z',
        updatedAt: '2022-10-28T06:30:10.307Z',
        publishedAt: '2022-10-28T06:30:10.305Z'
      }
    },
    {
      id: 23,
      attributes: {
        Title: 'Collaboration Title',
        page: 'collaboration-title',
        Instruction:
          '<p>Please submit one survey per corporate association and branch. Report association-wide collaborations in your Corporate Y response (e.g., a community-wide plan with Red Cross on how to respond to emergencies) and branch-specific collaborations at the branch level. Select your Y below to enter responses for your corporate association and/or branch(es).</p>',
        createdAt: '2022-10-28T07:30:28.298Z',
        updatedAt: '2022-10-28T07:30:32.029Z',
        publishedAt: '2022-10-28T07:30:32.027Z'
      }
    },
    {
      id: 24,
      attributes: {
        Title: 'Program Activities Sub',
        page: 'program-activities-sub',
        Instruction:
          '<p>The Programs and Activities section is organized by the 5 tabs below. Answer the first question on this tab to indicate whether your Y offered any programs or services during 2022. If your Y did not, you can simply select no and you will not be asked to answer any of the questions in this section.</p>',
        createdAt: '2022-10-28T08:50:09.885Z',
        updatedAt: '2022-10-28T08:50:12.170Z',
        publishedAt: '2022-10-28T08:50:12.168Z'
      }
    },
    {
      id: 25,
      attributes: {
        Title: 'Pledge',
        page: 'pledge',
        Instruction:
          '<p><strong>Instructions</strong></p><ol style="list-style-type:decimal;"><li><span style="color:hsl(0,0%,0%);"><strong>Pledge your Commitment: </strong>The CEO and the chief volunteer officer (CVO) affirm their commitment to upholding the statement of purpose and membership criteria established by the </span><a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/MjE4ODY"><span style="color:hsl(0,0%,0%);">Constitution and Bylaws of the National Council of Young Men’s Christian Associations of the United States of America </span></a><span style="color:hsl(0,0%,0%);">(YMCA National Constitution).</span></li><li><span style="color:hsl(0,0%,0%);"><strong>Sign the Pledge Statement: </strong>The CEO and the CVO indicate acceptance of the statement of purpose and membership criteria. For the 2023 certification year, CEOs and CVOs enter their name preceded and followed by forward slashes(e.g.,/JohnDoe/) for the required electronic signature at the bottom of the Pledge Statement.</span></li><li><span style="color:hsl(0,0%,0%);"><strong>Do Not Delegate: </strong>Unlike other sections of the annual report, the CEO may not delegate the Pledge Statement to a staff member for completion.</span></li><li><span style="color:hsl(0,0%,0%);"><strong>Review the key questions for the CEO section: </strong>This section includes checkboxes that the CEO can choose to mark.&nbsp;</span></li></ol>',
        createdAt: '2022-10-28T09:08:59.263Z',
        updatedAt: '2023-01-30T11:51:10.727Z',
        publishedAt: '2022-10-28T09:09:04.917Z'
      }
    },
    {
      id: 26,
      attributes: {
        Title: 'Review & Submit',
        page: 'review-and-submit',
        Instruction:
          '<p>Please review all of your responses and verify that you have provided all of the requested information before hitting the submit button below. Once submitted, you will be able to view your responses but you will not be able to edit or modify them without submitting a <a target="_blank" rel="noopener noreferrer" href="https://go.ymca.net/formstack/annualreport_support">request for support</a>.</p>',
        createdAt: '2022-10-28T09:41:52.478Z',
        updatedAt: '2023-01-05T17:24:24.568Z',
        publishedAt: '2022-10-28T09:41:56.018Z'
      }
    },
    {
      id: 27,
      attributes: {
        Title: 'Membership Know Your Community',
        page: 'membership-know-your-community',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.</p>',
        createdAt: '2022-11-02T09:47:56.345Z',
        updatedAt: '2022-12-05T12:20:22.278Z',
        publishedAt: '2022-11-02T09:47:58.724Z'
      }
    },
    {
      id: 28,
      attributes: {
        Title: 'Leadership / Staff Development',
        page: 'leadership-staff-development',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.&nbsp;</p>',
        createdAt: '2022-11-02T09:49:29.595Z',
        updatedAt: '2022-11-02T09:49:35.231Z',
        publishedAt: '2022-11-02T09:49:35.229Z'
      }
    },
    {
      id: 35,
      attributes: {
        Title: 'Program Innovation',
        page: 'program-innovation',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.&nbsp;</p>',
        createdAt: '2022-11-02T11:41:14.609Z',
        updatedAt: '2022-11-02T11:41:17.253Z',
        publishedAt: '2022-11-02T11:41:17.251Z'
      }
    },
    {
      id: 37,
      attributes: {
        Title: 'Strategic Relationships',
        page: 'strategic-relationships',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.&nbsp;</p>',
        createdAt: '2022-11-02T11:47:33.143Z',
        updatedAt: '2022-11-02T11:47:35.253Z',
        publishedAt: '2022-11-02T11:47:35.251Z'
      }
    },
    {
      id: 38,
      attributes: {
        Title: 'Resource Mobilization',
        page: 'resource-mobilization',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.&nbsp;</p>',
        createdAt: '2022-11-02T12:15:52.541Z',
        updatedAt: '2022-11-02T12:15:54.585Z',
        publishedAt: '2022-11-02T12:15:54.582Z'
      }
    },
    {
      id: 39,
      attributes: {
        Title: 'Brand Visibility',
        page: 'brand-visibility',
        Instruction:
          '<p>This section of the annual report collects information about the diversity, inclusion, and global (DIG) engagement practices at your Y. Please include any information from your branches in this single association-level submission.&nbsp;</p>',
        createdAt: '2022-11-02T12:16:29.049Z',
        updatedAt: '2022-11-02T12:16:32.865Z',
        publishedAt: '2022-11-02T12:16:32.863Z'
      }
    },
    {
      id: 40,
      attributes: {
        Title: 'Other Not-for-Profit Organizations',
        page: 'other-not-for-profit-organizations',
        Instruction:
          '<p>Select whether your Y collaborated with other organizations or not. If your Y did not collaborate with other organizations, you can simply select no and you will not be asked to answer any of the questions in this section.</p><p>Check the box(es) which best describe the purpose/focus of your collaboration(s). Choose all that apply, whether more than one applies to a single collaboration, or if you have multiple collaborations with the same type of organization.</p>',
        createdAt: '2022-11-02T12:21:04.704Z',
        updatedAt: '2022-12-06T06:52:42.658Z',
        publishedAt: '2022-11-02T12:21:27.095Z'
      }
    },
    {
      id: 41,
      attributes: {
        Title: 'chronic-disease-program',
        page: 'chronic-disease-program',
        // Instruction:
        //   '<p>Please upload your Chronic Disease Program Data using the drop-down options below. Select the program and the data collection system. Once both options are selected you can upload your spreadsheet/fetch program data.</p><p>For more information, please see Chronic Disease Program Module User Guide.</p>',
        Instruction:
          '<p>Please upload your Chronic Disease Program Data using the drop-down options below. Select both the program and the data collection system. Once both options are selected you will be instructed to either upload your spreadsheet with data or to initiate a fetch of your program data (fetch available for REDCap only). After taking this step, you will be prompted to review the data submission and confirm it is correct before importing.</p><p>Please note, you will need to do this step for each program run by your Y.</p><p>For more information, please see Chronic Disease Program Module User Guide</p>',
        createdAt: '2022-11-02T12:21:04.704Z',
        updatedAt: '2022-12-06T06:52:42.658Z',
        publishedAt: '2022-11-02T12:21:27.095Z'
      }
    },
    {
      id: 42,
      attributes: {
        Title: 'Government Organizations & Their Affiliates',
        page: 'government-organizations-and-their-affiliates',
        Instruction:
          '<p>Select whether your Y collaborated with other organizations or not. If your Y did not collaborate with other organizations, you can simply select no and you will not be asked to answer any of the questions in this section.</p><p>Check the box(es) which best describe the purpose/focus of your collaboration(s). Choose all that apply, whether more than one applies for a single collaboration, or if you have multiple collaborations with the same type of organization.</p>',
        createdAt: '2022-11-02T12:22:56.048Z',
        updatedAt: '2022-12-06T06:53:30.796Z',
        publishedAt: '2022-11-02T12:22:57.729Z'
      }
    },
    {
      id: 43,
      attributes: {
        Title: 'Other Community Organizations',
        page: 'other-community-organizations',
        Instruction:
          '<p>Select whether your Y collaborated with other organizations or not. If your Y did not collaborate with other organizations, you can simply select no and you will not be asked to answer any of the questions in this section.</p><p>Check the box(es) which best describe the purpose/focus of your collaboration(s). Choose all that apply, whether more than one applies for a single collaboration, or if you have multiple collaborations with the same type of organization.</p>',
        createdAt: '2022-11-02T12:24:02.431Z',
        updatedAt: '2022-12-06T06:54:01.761Z',
        publishedAt: '2022-11-02T12:24:05.034Z'
      }
    },
    {
      id: 44,
      attributes: {
        Title: 'Private Organizations and Businesses',
        page: 'private-organizations-and-businesses',
        Instruction:
          '<p>Select whether your Y collaborated with other organizations or not. If your Y did not collaborate with other organizations, you can simply select no and you will not be asked to answer any of the questions in this section.</p><p>Check the box(es) which best describe the purpose/focus of your collaboration(s). Choose all that apply, whether more than one applies for a single collaboration, or if you have multiple collaborations with the same type of organization.</p>',
        createdAt: '2022-11-02T12:24:50.765Z',
        updatedAt: '2022-12-06T06:54:21.607Z',
        publishedAt: '2022-11-02T12:24:52.209Z'
      }
    },
    {
      id: 45,
      attributes: {
        Title: 'Collaborations Among Ys',
        page: 'collaborations-among-ys',
        Instruction:
          '<p>Select whether your Y collaborated with other organizations or not. If your Y did not collaborate with other organizations, you can simply select no and you will not be asked to answer any of the questions in this section.</p><p>Check the box(es) which best describe the purpose/focus of your collaboration(s). Choose all that apply, whether more than one applies for a single collaboration, or if you have multiple collaborations with the same type of organization.</p>',
        createdAt: '2022-11-02T12:25:25.051Z',
        updatedAt: '2022-12-06T06:51:21.160Z',
        publishedAt: '2022-11-02T12:25:26.911Z'
      }
    },
    {
      id: 46,
      attributes: {
        Title: 'Housing',
        page: 'housing',
        Instruction:
          '<p>The Programs and Activities section is organized by the 5 tabs below. Answer the first question on this tab to indicate whether your Y offered any programs or services during 2022. If your Y did not, you can simply select no and you will not be asked to answer any of the questions in this section.</p>',
        createdAt: '2022-11-02T12:27:27.378Z',
        updatedAt: '2022-11-02T12:27:29.225Z',
        publishedAt: '2022-11-02T12:27:29.223Z'
      }
    },
    {
      id: 47,
      attributes: {
        Title: 'Food Programs',
        page: 'food-programs',
        Instruction:
          '<p>The Programs and Activities section is organized by the 5 tabs below. Answer the first question on this tab to indicate whether your Y offered any programs or services during 2022. If your Y did not, you can simply select no and you will not be asked to answer any of the questions in this section.</p>',
        createdAt: '2022-11-02T12:27:58.546Z',
        updatedAt: '2022-11-02T12:28:01.116Z',
        publishedAt: '2022-11-02T12:28:01.114Z'
      }
    },
    {
      id: 48,
      attributes: {
        Title: 'Armed Services',
        page: 'armed-services',
        Instruction:
          '<p>The Programs and Activities section is organized by the 5 tabs below. Answer the first question on this tab to indicate whether your Y offered any programs or services during 2022. If your Y did not, you can simply select no and you will not be asked to answer any of the questions in this section.</p>',
        createdAt: '2022-11-02T12:28:48.475Z',
        updatedAt: '2022-11-02T12:28:50.039Z',
        publishedAt: '2022-11-02T12:28:50.036Z'
      }
    },
    {
      id: 49,
      attributes: {
        Title: 'Older Adults',
        page: 'older-adults',
        Instruction:
          '<p>The Programs and Activities section is organized by the 5 tabs below. Answer the first question on this tab to indicate whether your Y offered any programs or services during 2022. If your Y did not, you can simply select no and you will not be asked to answer any of the questions in this section.</p>',
        createdAt: '2022-11-02T12:29:15.358Z',
        updatedAt: '2022-11-02T12:29:17.192Z',
        publishedAt: '2022-11-02T12:29:17.191Z'
      }
    },
    {
      id: 50,
      attributes: {
        Title: 'Current & Incoming CVO Information',
        page: 'current-and-incoming-cvo-information',
        Instruction:
          "<p>Review and update your Association’s current and incoming CVO information. Updates made here will be reflected in MOYP within 24 hours of saving this form.</p><p>To avoid extra reporting steps for YMCAs at the time of CVO/Board Chair transitions, Y-USA will collect the name, email address and term for each Y association's current and incoming CVO/Board Chair. You will still be able to edit current and incoming CVO information via MOYP throughout the year if changes are needed outside of the Annual Reporting process.&nbsp;<br>&nbsp;</p>",
        createdAt: '2022-11-02T12:30:25.575Z',
        updatedAt: '2022-12-07T18:51:43.901Z',
        publishedAt: '2022-11-02T12:30:27.026Z'
      }
    },
    {
      id: 58,
      attributes: {
        Title: 'Sub Pledge 1',
        page: 'sub-pledge-1',
        Instruction:
          '<p><span style="color:#00AEEF;"><strong>Annual Certification Pledge Statement for the CEO and the CVO/Board Chair</strong></span></p>',
        createdAt: '2022-11-30T06:52:41.566Z',
        updatedAt: '2022-11-30T11:08:01.406Z',
        publishedAt: '2022-11-30T06:52:43.896Z'
      }
    },
    {
      id: 59,
      attributes: {
        Title: 'Sub Pledge 2',
        page: 'sub-pledge-2',
        Instruction: `<p style=\"margin-left:0px;\">a. That our association accepts and supports the statement of purpose of the Young Men's Christian Associations of the United States of America,&nbsp;which is: The Young Men's Christian Association we regard as being in its essential genius a worldwide fellowship united by a common loyalty to&nbsp;Jesus Christ for the purpose of developing Christian personality and building a Christian society.&nbsp;<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://link.ymca.net/mlink/file/MjYyMTY?type=attachment\"><span style=\"color:#00AEEF;\"><u>Learn more.</u></span></a></p><p style=\"margin-left:0px;\">b. That our governing documents provide that it shall be designated as a Young Men's Christian Association and which is organized and operated in conformity with this Constitution.</p><p style=\"margin-left:0px;\">c. That our association accepts the constitution of the National Council of YMCAs of the&nbsp;United States of America.</p><p style=\"margin-left:0px;\">d. That our association pays monthly to the National Council one-twelfth, of its share of the fair share support of the National Council by electronic fund transfer,&nbsp;or such other means as directed by the National Council;&nbsp;Provided that in exceptional circumstances a member association may be released from this requirement in whole or in part and on conditions by the action of the National Board</p><p style=\"margin-left:0px;\">e. That our association will annually report to the National Board concerning such matters as the Board may request from time to time.</p><p style=\"margin-left:0px;\">f. That our association chief employed officer meets the education and&nbsp;training qualifications of that position as determined by the National Board.</p><p style=\"margin-left:0px;\">g. That our association will annually certify that it does not unlawfully discriminate against its staff, board, volunteers, committees, or recipients&nbsp;of services based on any characteristic or status protected by federal, state, or local law and is committed to a culture of inclusion, and understands, respects and values the diversity of others.&nbsp;<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://link.ymca.net/mlink/site_page/NDEw\"><span style=\"color:#00AEEF;\"><u>Learn more.</u></span></a></p><p style=\"margin-left:0px;\">h. That our association is recognized by the Internal Revenue Service as an exempt organization described in Section 501(c) (3) of the Internal Revenue Code of 1986 as amended&nbsp;or any successor provision thereto and conforms to applicable federal. state or local laws regulating charitable nonprofit or not-for-profit corporations.</p><p style=\"margin-left:0px;\">i. That our association will annually acknowledge that it shall use the legal name&nbsp;\"Young Men's Christian Association\" and all names, marks, logos, symbols, and other intellectual property as authorized by the National Council; that such intellectual property is the property of the National Council, and that as a member association we have a limited, revocable, non-exclusive and non-transferable right and duty to use the such intellectual property only as permitted by the National Board through its policies and guidelines to protect the YMCA brand and reputation.</p><p style=\"margin-left:0px;\">j. That our association will annually certify that, notwithstanding its autonomy, it recognizes its responsibility&nbsp;as part of a national movement; it shall not act in a manner which the National Board, Through its National Committee on Membership Standards, determines adversely impacts the reputation of other member associations, the YMCA brand or the national movement.</p><p style=\"margin-left:0px;\">k. That our association will annually certify that&nbsp;notwithstanding its local autonomy, it shall meet child abuse prevention and aquatic safety practices specified by the National Board.</p>`,
        createdAt: '2022-11-30T06:57:29.494Z',
        updatedAt: '2022-12-30T08:38:54.834Z',
        publishedAt: '2022-11-30T06:57:31.847Z'
      }
    },
    {
      id: 59,
      attributes: {
        Title: 'Sub Pledge 2',
        page: 'sub-pledge-2-2025',
        Instruction: `<p style=\"margin-left:0px;\">a. That our association accepts and supports the statement of purpose of the Young Men's Christian Associations of the United States of America,&nbsp;which is: The Young Men's Christian Association we regard as being in its essential genius a worldwide fellowship united by a common loyalty to&nbsp;Jesus Christ for the purpose of developing Christian personality and building a Christian society.&nbsp;<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://link.ymca.net/mlink/file/MjYyMTY?type=attachment\"><span style=\"color:#00AEEF;\"><u>Learn more.</u></span></a></p><p style=\"margin-left:0px;\">b. That our governing documents provide that it shall be designated as a Young Men's Christian Association and which is organized and operated in conformity with this Constitution.</p><p style=\"margin-left:0px;\">c. That our association accepts the constitution of the National Council of YMCAs of the&nbsp;United States of America.</p><p style=\"margin-left:0px;\">d. That our association pays monthly to the National Council one-twelfth, of its share of the fair share support of the National Council by electronic fund transfer,&nbsp;or such other means as directed by the National Council;&nbsp;Provided that in exceptional circumstances a member association may be released from this requirement in whole or in part and on conditions by the action of the National Board</p><p style=\"margin-left:0px;\">e. That our association will annually report to the National Board concerning such matters as the Board may request from time to time.</p><p style=\"margin-left:0px;\">f. That our association chief employed officer meets the education and&nbsp;training qualifications of that position as determined by the National Board.</p><p style=\"margin-left:0px;\">g. That our association will annually certify that it does not unlawfully discriminate against its staff, board, volunteers, committees, or recipients&nbsp;of services based on any characteristic or status protected by federal, state, or local law.</p><p style=\"margin-left:0px;\">h. That our association is recognized by the Internal Revenue Service as an exempt organization described in Section 501(c) (3) of the Internal Revenue Code of 1986 as amended&nbsp;or any successor provision thereto and conforms to applicable federal. state or local laws regulating charitable nonprofit or not-for-profit corporations.</p><p style=\"margin-left:0px;\">i. That our association will annually acknowledge that it shall use the legal name&nbsp;\"Young Men's Christian Association\" and all names, marks, logos, symbols, and other intellectual property as authorized by the National Council; that such intellectual property is the property of the National Council, and that as a member association we have a limited, revocable, non-exclusive and non-transferable right and duty to use the such intellectual property only as permitted by the National Board through its policies and guidelines to protect the YMCA brand and reputation.</p><p style=\"margin-left:0px;\">j. That our association will annually certify that, notwithstanding its autonomy, it recognizes its responsibility&nbsp;as part of a national movement; it shall not act in a manner which the National Board, Through its National Committee on Membership Standards, determines adversely impacts the reputation of other member associations, the YMCA brand or the national movement.</p><p style=\"margin-left:0px;\">k. That our association will annually certify that&nbsp;notwithstanding its local autonomy, it shall meet child abuse prevention and aquatic safety practices specified by the National Board.</p>`,
        createdAt: '2022-11-30T06:57:29.494Z',
        updatedAt: '2022-12-30T08:38:54.834Z',
        publishedAt: '2022-11-30T06:57:31.847Z'
      }
    },
    {
      id: 59,
      attributes: {
        Title: 'Sub Pledge 5',
        page: 'sub-pledge-5',
        Instruction:
          '<p><span style="color:#00AEEF;"><strong>Trademark License Statement for CEO and CVO/Board Chair</strong></span></p>',
        createdAt: '2022-11-30T06:52:41.566Z',
        updatedAt: '2022-11-30T11:08:01.406Z',
        publishedAt: '2022-11-30T06:52:43.896Z'
      }
    },
    {
      id: 59,
      attributes: {
        Title: 'Sub Pledge 6',
        page: 'sub-pledge-6',
        Instruction: `<p style=\"margin-left:0px;\"><strong>1. License Grant:</strong> Subject to the terms and conditions herein, YMCA of the USA (“Licensor”) hereby grants to you/Member Association (“Licensee”) a non-exclusive, non-transferable license to use YMCA, U.S. Reg. No. 668,795, The Y YMCA Logo, U.S. Reg. No. 3,917,712 and other U.S. federally protected trademarks owned by Licensor (collectively “YUSA Trademarks”) solely in connection with programs and services provided within its service area.&nbsp;</p><p style=\"margin-left:0px;\"><strong>2. Ownership:</strong> The Licensee acknowledges that the Licensor is the sole and exclusive owner of YUSA Trademarks as governed by Article VIII of the National Council of Young Men’s Christian Associations of the United States of America’s Constitution and Bylaws. The Licensee shall not contest or challenge the Licensor's ownership of YUSA Trademarks or take any action inconsistent with such ownership. Should Licensee cease to operate as a Member Association it, including all volunteers, officers, directors, agents, and employees agree to cease use of YUSA Trademarks and remove all YUSA Trademarks in accordance with the guidelines outlined in the NCMS Manual.</p><p style=\"margin-left:0px;\"><strong>3. Use/Markings:</strong> The Licensee shall use YUSA Trademarks strictly in accordance with the standards and guidelines provided by the Licensor as outlined in Licensor’s NCMS Manual, Sublicense Agreement Program, and Brand Resource Guidelines (collectively “YUSA Trademark Guidelines”) within its service area(s).</p><p style=\"margin-left:0px;\">The Licensee shall display YUSA Trademarks in the form and manner directed and approved by the Licensor. The Licensee shall include any legends, markings, or notices (e.g., YMCA®) required by the Licensor to indicate the trademark rights of the Licensor.</p><p style=\"margin-left:0px;\"><strong>4. Quality Control:</strong> The Licensee shall permit the Licensor to inspect its use of YUSA Trademarks to ensure compliance with the quality standards as outlined in YUSA’s Trademark Guidelines. Any deviations from these standards must be corrected promptly upon notice from the Licensor.</p><p style=\"margin-left:0px;\"><strong>5. Derivatives/Trademark Protection:</strong> The Licensee agrees that it will not (a) create a trademark and/or (b) seek trademark protection for derivatives of the YUSA Trademarks, including terms with the singular letter “Y” inferring it’s an acronym for or associated with a YMCA.</p><p style=\"margin-left:0px;\"><strong>6. Sublicense Grant:</strong> Subject to the Licensee entering YUSA’s Sublicense Agreement Program, the Licensee may grant a limited, non-exclusive, non-transferable sublicense to use YUSA Trademarks to third parties solely in connection with programs and services provided within its service area. Each sublicense shall be in writing and in accordance with YUSA’s Sublicense Agreement Program.</p><p style=\"margin-left:0px;\">Licensee acknowledges and agrees that it is not permitted to sublicense YUSA trademarks to third parties (i.e., sports teams, media, nationwide/global brands, etc.) outside its service area indicating a nationwide relationship. All such requests must be reviewed and approved by YUSA. If the third-party is to be granted a license, it will be entered into and granted by YUSA.</p><p style=\"margin-left:0px;\"><strong>7. Term:</strong> The license granted herein shall commence on the Effective Date of the Annual Report and must be acknowledged and agreed to annually by Licensee, unless terminated earlier by the Licensor.</p>`,
        createdAt: '2022-11-30T06:52:41.566Z',
        updatedAt: '2022-11-30T11:08:01.406Z',
        publishedAt: '2022-11-30T06:52:43.896Z'
      }
    },
    {
      id: 60,
      attributes: {
        Title: 'Employee Change Log Details',
        page: 'employee-change-log-details',
        Instruction:
          '<p>The change log details below will reflect all employee-related changes that you have made within the Employee Update module on the Data Collection Hub. Please note that changes that have been completed in Manage Our Y Profile (MOYP) will not be reflected below. To see your current staff records, which reflect all changes made, click ‘Upload New Data’ then ‘Download Existing Data’ or view them in MOYP.&nbsp;</p>',
        createdAt: '2023-02-23T07:30:50.698Z',
        updatedAt: '2023-02-23T07:30:53.273Z',
        publishedAt: '2023-02-23T07:30:53.269Z'
      }
    },
    {
      id: 61,
      attributes: {
        Title: 'Volunteer Registration',
        page: 'volunteer-registration',
        Instruction:
          '<p>Please verify your contact details below and use the upload functionality to submit your required information and documentation. For making any changes, please use the edit button/pencil icon to update fields or upload new documents.&nbsp;<br>If you have questions, please contact Meredith Griffin, <a href="mailto:Meredith.Griffin@ymca.net" target="_blank">Meredith.Griffin@ymca.net</a></p>',
        createdAt: '2023-03-08T08:51:33.437Z',
        updatedAt: '2023-03-08T08:51:43.766Z',
        publishedAt: '2023-03-08T08:51:43.762Z'
      }
    },
    {
      id: 62,
      attributes: {
        Title: 'Upload User Data',
        page: 'upload-user-data',
        Instruction:
          '<p>Follow the steps below to download a sample bulk user upload template and insert new users details via a bulk upload process.</p>',
        createdAt: '2023-05-12T09:28:42.087Z',
        updatedAt: '2023-05-12T09:28:45.377Z',
        publishedAt: '2023-05-12T09:28:45.372Z'
      }
    },
    {
      id: 63,
      attributes: {
        Title: 'User update review',
        page: 'user-update-review',
        Instruction:
          '<p>Please review the data you have uploaded using the table below. Once your data has been reviewed and finalized, please scroll to the bottom of this page in order to finalize and submit your user data.</p><p>IMPORTANT: Only New Users will consider for upload. Existing User and Error records will exclude from the upload process.</p>',
        createdAt: '2023-05-12T09:29:23.966Z',
        updatedAt: '2023-05-12T09:29:27.138Z',
        publishedAt: '2023-05-12T09:29:27.134Z'
      }
    },
    {
      id: 64,
      attributes: {
        Title: 'Upload Profiles ',
        page: 'upload-profile-data',
        Instruction:
          '<p>Please upload your Safety Around Water or Water Safety Program Student Profile Data by using the drop-down options below.</p><div class="raw-html-embed"><ul><li>Select the YMCA branch or center responsible for hosting this class.  If the program was held at an off-site location, select the branch or center that was responsible for program delivery.</li>\n<li>Select the program or lesson session that you would like the data tied to.  Note, that if there is no program available to select or the program date you are looking for is not available, you will need to go to your Dashboard and create the appropriate program with the parameters for the class that was held.</li>\n<li>Once both options are selected you can bulk upload your excel spreadsheet with your data.</li></ul></div><p>If your Y offers more than one class session of Safety Around water or water safety programming, please use one excel spreadsheet per program to upload your data into the system.&nbsp;</p><p>On the next screen you will be able to review, validate and import your data into the system.&nbsp;</p>',
        createdAt: '2023-08-31T12:22:42.268Z',
        updatedAt: '2023-09-06T09:45:56.424Z',
        publishedAt: '2023-08-31T12:22:44.455Z'
      }
    },
    {
      id: 65,
      attributes: {
        Title: 'Educational Organizations',
        page: 'educational-organizations',
        Instruction:
          '<p>Select whether your Y collaborated with other organizations or not. If your Y did not collaborate with other organizations, you can simply select no and you will not be asked to answer any of the questions in this section.</p><p>Check the box(es) which best describe the purpose/focus of your collaboration(s). Choose all that apply, whether more than one applies for a single collaboration, or if you have multiple collaborations with the same type of organization.</p>',
        createdAt: '2023-10-11T09:47:38.808Z',
        updatedAt: '2023-10-11T09:47:55.864Z',
        publishedAt: '2023-10-11T09:47:55.861Z'
      }
    },
    {
      id: 66,
      attributes: {
        Title: 'chronic-disease-program-view-details',
        page: 'chronic-disease-program-view-details',
        Instruction:
          '<p>Please review your data below. Valid records will be displayed in the DPRP format. Invalid records will be displayed with additional explanation as to why the records errored out and how to correct the record in order to have it be accepted in the system. Please fix your errored data in your source system and reupload the data into the module before you can import the data.</p><p>Any records that are deleted from the system cannot be retrieved and you will need to reupload with an additional file.</p><p>Once you have reviewed all your data, please scroll to the bottom of the page to confirm and import.</p>',
        createdAt: '2023-10-11T09:51:45.255Z',
        updatedAt: '2023-10-11T09:51:49.851Z',
        publishedAt: '2023-10-11T09:51:49.849Z'
      }
    },
    {
      id: 67,
      attributes: {
        Title: 'Annual Report Association Dashboard',
        page: 'annual-report-association-dashboard',
        Instruction:
          '<p>The submission status of your Annual Report Nonfinacials shown here does not reflect the Employee Update. Please ensure that you have updated your employee records as part of your Annual Report completion requirement.</p>',
        createdAt: '2023-10-11T09:51:45.255Z',
        updatedAt: '2023-10-11T09:51:49.851Z',
        publishedAt: '2023-10-11T09:51:49.849Z'
      }
    },
    {
      id: 63,
      attributes: {
        Title: 'Insurance association dashboard',
        page: 'insurance-association-dashboard',
        Instruction:
          '<p>Upload your YMCA’s certificate of liability insurance below. <a href="https://datacollectionhub-cms.y.org/uploads/certificate_of_insurance_sample_670eb1c465.pdf" target="_blank">Download this sample</a> showing the required wording for your document. Once your document has been uploaded, YUSA team members will review and approve your certificate. If you have any questions or issues using this module to upload your document, please contact Meredith Griffin at Meredith.Griffin@ymca.net.</p>',
        createdAt: '2022-10-18T09:17:45.791Z',
        updatedAt: '2023-02-15T18:29:30.327Z',
        publishedAt: '2022-10-18T09:18:28.827Z'
      }
    },

    {
      id: 64,
      attributes: {
        Title: 'Sub Pledge 3',
        page: 'sub-pledge-3',
        Instruction:
          '<p><span style="color:#00AEEF;"><strong>Board and Bylaw Statement for the CEO and CVO/Board Chair</strong></span></p>',
        createdAt: '2022-11-30T06:52:41.566Z',
        updatedAt: '2022-11-30T11:08:01.406Z',
        publishedAt: '2022-11-30T06:52:43.896Z'
      }
    },
    {
      id: 65,
      attributes: {
        Title: 'Sub Pledge 4',
        page: 'sub-pledge-4',
        Instruction: `<p style=\"margin-left:0px;\">a. The member association's Board annually reviews its Bylaws.</p><p style=\"margin-left:0px;\">b. The Bylaws follow state and local guidelines.</p><p style=\"margin-left:0px;\">c. The Board's policies and procedures are inclusive of language included on the IRS Form 990, Part VI, Section B—conflict of interest, whistleblower, document retention and destruction.</p>`,
        createdAt: '2022-11-30T06:57:29.494Z',
        updatedAt: '2022-12-30T08:38:54.834Z',
        publishedAt: '2022-11-30T06:57:31.847Z'
      }
    },
    {
      id: 66,
      attributes: {
        Title: 'Sub Pledge 4 2025',
        page: 'sub-pledge-4-2025',
        Instruction: `<p style=\"margin-left:0px;\">a. The member association’s Board reviews its Bylaws every three years.</p><p style=\"margin-left:0px;\">b. The Bylaws follow state and local guidelines.</p><p style=\"margin-left:0px;\">c. The Board's policies and procedures are inclusive of language included on the IRS Form 990, Part VI, Section B—conflict of interest, whistleblower, document retention and destruction.</p>`,
        createdAt: '2022-11-30T06:57:29.494Z',
        updatedAt: '2022-12-30T08:38:54.834Z',
        publishedAt: '2022-11-30T06:57:31.847Z'
      }
    },
    {
      id: 69,
      attributes: {
        Title: 'chronic-disease-program-upload-page',
        page: 'chronic-disease-program-upload-page',
        Instruction:
          '<p><img src="https://datacollectionhub-cms.y.org/uploads/diamond_marker_5783b38d82.svg" alt="Frame 29141.jpg"> For additional information and questions on how to submit data please reference the <a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/Njk4MjQ2?type=attachment">Chronic Disease Program Guide</a>. If you still have questions and need additional assistance, please submit a <a target="_blank" rel="noopener noreferrer" href="https://go.ymca.net/formstack/datacollhub_support">support ticket</a>.</p>',
        createdAt: '2024-10-07T10:36:38.930Z',
        updatedAt: '2024-10-07T10:45:45.173Z',
        publishedAt: '2024-10-07T10:36:43.309Z'
      }
    },
    {
      id: 73,
      attributes: {
        Title: 'Upload Metadata Data',
        page: 'upload-metadata-data',
        Instruction:
          '<p>Follow the steps below to edit or replace existing Metadata.</p><ul><li>Please use the drop-down menus to select the correct domain and year for downloading existing data or uploading new data.</li><li>You will be able to review and validate records post uploading your new file to the system.</li><li>Data must be confirmed and imported into the system on the next screen to have your metadata changes updated.</li></ul>',
        createdAt: '2024-11-01T09:11:41.937Z',
        updatedAt: '2024-11-01T09:12:09.951Z',
        publishedAt: '2024-11-01T09:12:09.945Z'
      }
    },
    {
      id: 74,
      attributes: {
        Title: 'Review Metadata Data',
        page: 'review-metadata-data',
        Instruction: `<ul><li>If your data is free of any errors, please review and validate your data. Scroll to the bottom of the page and confirm the data can be imported into the system.</li><li> If your data has errors, please review, and fix those errors. You will need to update your excel file and reupload into the system. On this page you can also download your errors into a spreadsheet to review and email yourself an email regarding those errors if you want to fix those and reupload at a later time.</li><ul>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 75,
      attributes: {
        Title: 'Total Staff',
        page: 'total-staff',
        Instruction: `<p>Full-time employees should be reported as your Camp defined them. A typical definition of Full-time would be 30 or more hours per week, minimum 1,500 hours per year. Include international staff, who are most commonly seasonal employees but include them in the category that best scribes them at your Camp.</p><p> For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions.</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 76,
      attributes: {
        Title: 'Wages',
        page: 'wages',
        Instruction: `<p>Please include the wage paid for this position. Exclude earning from work that individuals may perform from other duties at your Camp, Overtime Pay, Bonuses, Incentive Pay, Profit Sharing, and the monetary value of any other benefits that may be provided. If multiple persons hold the same title, use the highest paid for your estimates.</p><p> For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions.</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 77,
      attributes: {
        Title: 'Enrollment and Occupancy',
        page: 'enrollment-and-occupancy',
        Instruction: `<p>The following section will ask you to provide details on your Enrollment. The value selected determines the number of rows to appear in a table below. The column/data points asked will remain the same. Please note that you can add additional rows at any point and can also remove rows.&nbsp;</p><p>Sessions, in this case, refer to the number of unique timeframes and price points for which you register campers. For example, if you offer campers the choice of 2 – four week options, then you would put 2 in the box. If you offer campers the choice of 1 week, 2 week and 4 week sessions, you would add up the total number of options for each length. For example, 2 – 4 week options, 4 – 2 week options and 8 – 1 week options would total 14 sessions.</p><p>If your camp offers multiple camp programs within the same timeframe, each unique price point will count as one session. For example, during week 1 of the season, Camp No Fun (300 camper beds) offers youth (150 beds, $500/camper), teen (100 beds, $500/camper) and leadership (50 beds,$300/camper) camps simultaneously. This would count as 2 sessions. Session 1 would be 250 campers at $500/camper and Session 2 would be 50 campers at $50/camper.</p><p>If you utilize tiered pricing, please list your highest tiered price when filling out the chart below.&nbsp;</p><p>For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions. &nbsp;</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 78,
      attributes: {
        Title: 'Participants',
        page: 'participants',
        Instruction: `<p>The following section will ask you to provide details on your Enrollment. Please click the Not Collection checkbox if you do not collect the specific data point for any of the categories below. Data should be provided only for campers, not camp staff.</p><p> For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions.</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 79,
      attributes: {
        Title: 'Revenue',
        page: 'revenue',
        Instruction: `<p>Please list your Overnight Summer Camp’s total operating revenue for the summer. Do not include revenue from other programs or services offered such as Day Camps, Retreats, Outdoor Education, etc.</p><p> For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions.</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 80,
      attributes: {
        Title: 'Expenses',
        page: 'expenses',
        Instruction: `<p>Please list your Overnight Summer Camp's total expenses for the summer.</p><p> For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions.</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 81,
      attributes: {
        Title: 'Program and Property',
        page: 'program-and-property',
        Instruction: `<p>Please provide answers to the following questions regarding your camp property and summer program mix. The information is being gathered to help us better understand the unique challenges and needs of camps.</p><p> ACA Accreditation is not a requirement. If you are not ACA accredited, we would like to better understand why and/or what barriers might be keeping your camp from being accredited.</p><p> For assistance to complete this section for your overnight summer camp, please refer to the Help Pane on the right side of your screen. When expanded, it will provide additional guidance and definitions.</p>`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    },
    {
      id: 82,
      attributes: {
        Title: 'Review and Submit Camp',
        page: 'review-and-submit-camp',
        Instruction: `Please review all of your responses and verify that you have provided all the requested information before hitting the submit button below. Once submitted, you  will be able to view your responses, but you will not be able to edit or modify them  without submitting a request for support.`,
        createdAt: '2024-11-01T09:21:46.270Z',
        updatedAt: '2024-11-01T09:21:53.218Z',
        publishedAt: '2024-11-01T09:21:53.213Z'
      }
    }
  ],
  meta: {
    pagination: {
      page: 1,
      pageSize: 100,
      pageCount: 1,
      total: 44
    }
  }
};

export default helpSectionPages;
